import { createContext, useContext, useMemo } from 'react';

import { FCC } from '@eluve/components';
import { useNamedLogger } from '@eluve/logger';

import { DexieDb, createDb } from './files-db';

const DbContext = createContext<DexieDb | null>(null);

export const useDb = () => {
  const context = useContext(DbContext);
  if (!context) {
    throw new Error('useDb must be used within a DbProvider');
  }

  return context;
};

export const DbProvider: FCC<{ userId: string; tenantId: string }> = ({
  userId,
  tenantId,
  children,
}) => {
  const logger = useNamedLogger('DbProvider');
  const db = useMemo(() => {
    logger.info('Creating local db');
    return createDb({ userId, tenantId, logger });
  }, [userId, tenantId, logger]);

  return <DbContext.Provider value={db}>{children}</DbContext.Provider>;
};
